import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardText,
  Button,
  CardSubtitle,
  Table,
  ModalFooter,
} from "reactstrap";
import { FaPlus, FaEdit, FaEye } from "react-icons/fa";
import axios from "axios";
import uuid from "react-uuid";
import Moment from "moment";
import "../ExternalOrganisation/ExternalOrganisation.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const FarmSubscriptions = () => {
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(0);
  const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [tempSubscriptionList, setTempSubscriptionList] = useState([]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Active":
        return { backgroundColor: "#d1fae5", color: "#065f46", fontWeight: 600, padding: "4px 8px", borderRadius: "6px", width: "fit-content" };
      case "Expired":
        return { backgroundColor: "#fee2e2", color: "#991b1b", fontWeight: 600, padding: "4px 8px", borderRadius: "6px", width: "fit-content" };
      default:
        return { backgroundColor: "#f3f4f6", color: "#374151", fontWeight: 600, padding: "4px 8px", borderRadius: "6px", width: "fit-content" };
    }
  };
  

  const populateItemData = async () => {
    try {
      const response = await axios.get(
        "/api/Subscription/GetFarmSubscriptionsByUser/",
        {
          params: { UserId: userId },
        }
      );
      setSubscriptionList(response.data.content);
      setTempSubscriptionList(response.data.content);
      setLoading(false);
    } catch (err) {
      if (!err?.response) {
      } else if (err.response?.status === 400) {
      } else {
      }
    }
  };

  useEffect(() => {
    populateItemData();
  }, []);

  const open = (id, routePath) => {
    navigate("/farm-subscription/" + routePath + "/" + id, {
      state: { id: id },
    });
  };

  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);
    if (sortConfig == null) {
      setSortConfig({ key: "name", direction: "ascending" });
    }
    const sortedItems = React.useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key) => {
      let direction = "ascending";
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
      setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
  };
  const ProductTable = (props) => {
    const { items, requestSort, sortConfig } = useSortableData(props.products);
    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };
    return (
      <Table striped bordered hover style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>
              {/* <button
                                type="button"
                                onClick={() => requestSort('subscriptionId')}
                                className={getClassNamesFor('subscriptionId')}
                            >
                                Farm Name
                            </button> */}
              Farm Name
            </th>
            {/* <th style={{ textAlign: "center" }}>
                            Status
                        </th> */}
            <th>
              {/* <button
                                type="button"
                                onClick={() => requestSort('email')}
                                className={getClassNamesFor('email')}
                            >
                                Email
                            </button> */}
              Subscription details
            </th>
            <th>
              {/* <button
                                type="button"
                                onClick={() => requestSort('type')}
                                className={getClassNamesFor('type')}
                            >
                                Farm Type
                            </button> */}
              Farm Type
            </th>
            <th>
              {/* <button
                                type="button"
                                onClick={() => requestSort('startDate')}
                                className={getClassNamesFor('startDate')}
                            >
                                Start Date
                            </button> */}
              Renew Date
            </th>
            <th>
              {/* <button
                                type="button"
                                onClick={() => requestSort('expiryDate')}
                                className={getClassNamesFor('expiryDate')}
                            >
                                Expiry Date
                            </button> */}
              Amount
            </th>
            <th>Next Renewal Date</th>
            <th>Subscription Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items == undefined && (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                Loading...
              </td>
            </tr>
          )}
          {items != undefined &&
            items != null &&
            items.map((item) => (
              <tr key={uuid()}>
                <td style={{ textAlign: "" }}>{item.farmName}</td>
                <td style={{ textAlign: "" }}>{item.subscriptionDetails} </td>
                <td style={{ textAlign: "" }}>{item.farmType} </td>
                <td style={{ textAlign: "" }}>{item.renewDate} </td>
                <td style={{ textAlign: "" }}>${item.amount} </td>
                <td style={{ textAlign: "" }}>{item.nextRenewalDate} </td>
                <td>
                    <span style={getStatusStyle(item.subscriptionStatus)}>
                    {item.subscriptionStatus}
                    </span>
                </td>
                <td>
                  <button
                    style={{ backgroundColor: "#0d535d" }}
                    type="button"
                    onClick={(id, routePath) => open(item.farmId, "watch")}
                    id="btnUpdate"
                    color="warning"
                    className="btn btn-sm btn-edit"
                  >
                    <FaEye />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  };

  const handleChangeName = async (event) => {
    setName(event.target.value);
    if (event.target.value == "") {
      setSubscriptionList(tempSubscriptionList);
    } else {
      var list = [];
      list = tempSubscriptionList.filter(
        (x) =>
          (x.subscriptionId != null
            ? x.subscriptionId
                .toLowerCase()
                .includes(event.target.value.toLowerCase())
            : 0) ||
          (x.email != null
            ? x.email.toLowerCase().includes(event.target.value.toLowerCase())
            : 0) ||
          (x.farms != null
            ? x.farms.toLowerCase().includes(event.target.value.toLowerCase())
            : 0) ||
          (x.type != null
            ? x.type.toLowerCase().includes(event.target.value.toLowerCase())
            : 0)
      );
      setSubscriptionList(list);
    }
  };

  return (
    <div>
      <Card className="my-2">
        <h3
          className="card-header d-flex justify-content-between align-items-center"
          style={{ background: "#0D535D", color: "#fff" }}
        >
          Farm list
        </h3>
        <CardBody>
          {/* <Row >
                        <Col md="9">
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label style={{ textTransform: "none", fontSize: "medium" }}>Search</Label>
                                <Input className="validate" type="text" value={name} onChange={handleChangeName} name="Name" id="Name" placeholder="" />
                            </FormGroup>
                        </Col>
                    </Row> */}
          <Row style={{ marginTop: "10px" }}>
            <Col>
              {subscriptionList == undefined && (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              )}
              {subscriptionList != undefined && subscriptionList != null && (
                <ProductTable products={subscriptionList} />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default FarmSubscriptions;
